import  { STORE_PUBLISH_FIELD_DETAILS_2 } from '../actions/storePublishFieldDetails2Actions';

interface PublishFields {
    region: string,
    product_id: string,
    product_description: string,
    pricing: number,
    country : string,
    province : string,
    origin: string,
    specification: string,
    currency:string
}

export const storePublishFieldDetails2Reducer= (
	state: PublishFields = {
        region: "emea",
        product_id: "51002",
        product_description: "Apple",
        currency: '£', 
        pricing: 1.25,
        country : "uk",
        province:"",
        origin: "Spain",
        specification: "Organic apples hand picked in Spain from sustainable farming. Package of 6"
    },
	action: {type:string, payload : {key:string, value:string}}
): any => {
	switch (action.type) {
		case STORE_PUBLISH_FIELD_DETAILS_2:
			return {
                ...state,
                [action.payload.key] :  action.payload.value
            };
		default:
			return state;
	}
}

